import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useUpdateUnsignedOrderMutation } from 'api/generated/graphql';
import {
  parseOrderEntity,
  parseUpdateUnsignedOrderParams,
  useError,
} from 'api/helpers';
import { useNotifyMessages } from 'api/helpers/useNotifyMessages';
import { UpdateUnsignedOrderParams } from 'api/types/params';

export const useUpdateUnsignedOrder = () => {
  const [updateOrder, { loading, error: apolloError }] =
    useUpdateUnsignedOrderMutation();

  const notifyMessage = useNotifyMessages();

  const error = useError(apolloError);

  return {
    updateUnsignedOrder: useCallback(
      async (
        id: string,
        versionNumber: number,
        params: UpdateUnsignedOrderParams
      ) => {
        const input = parseUpdateUnsignedOrderParams(versionNumber, params);
        const res = await updateOrder({
          variables: {
            id,
            input,
          },
        });

        notifyMessage(res.data?.updateUnsignedOrder?.messages);

        return res.data?.updateUnsignedOrder?.data
          ? parseOrderEntity(res.data?.updateUnsignedOrder?.data)
          : null;
      },
      [notifyMessage, updateOrder]
    ),
    loading,
    error,
  };
};
